import axios from "axios";
import { TOKEN, getAccessToken, refreshAccessToken } from "../auth/session";

// Kept here too, because older code imports TOKEN from this file
export { TOKEN };

const headers = {};

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL + "/api/v1",
  timeout: 20000,
  headers,
});

// Every request carries the stored access token (never one from the URL)
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getAccessToken();
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// A 401 means the access token is no longer accepted: refresh it once and retry
axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const original = error.config;
    const isUnauthorized = error.response && error.response.status === 401;

    if (isUnauthorized && original && !original._retried) {
      original._retried = true;
      const newToken = await refreshAccessToken();
      if (newToken) {
        original.headers["Authorization"] = `Bearer ${newToken}`;
        return axiosInstance(original);
      }
    }

    return Promise.reject(error);
  }
);

export default axiosInstance;
